import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from '../../environments/environment';
import {FileUploadSpec} from '../models/FileUploadSpec';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  private readonly baseUrl = environment.uploadUrl + "/";

  constructor(private httpClient: HttpClient) {
  }

  upload(file: File, endpoint: string): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.httpClient.post(this.baseUrl + endpoint, formData);
  }

  getSpec(endpoint: string): Observable<FileUploadSpec> {
    return this.httpClient.get<FileUploadSpec>(this.baseUrl + endpoint);
  }


}
